import React from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {Editor} from '../editor-components';
import Spinner from '../spinner/spinner';
import {Hall} from 'vexpo-components';

/** @class BothReviewer
  * A component for reviewing and approving booths and thier contents
  * in a virutal expo.
  */
export default class BoothReview extends ReactFireComponent {
  /** @constructor
    * Creates a new BoothEditor component
    */
  constructor(props) {
    super(props);
    const expoID = props.expoID
    const showID = props.showID
    const boothID = props.boothID
    this.state = {
      expoID: expoID,
      showID: showID,
      boothID: boothID
    }
    this.dataURL = `/expos/${expoID}/shows/${showID}/booths/${boothID}`;
    this.hallURL = `/expos/${expoID}/shows/${showID}/halls`;
  }
  /** @function componentWillMount
    * Connects the component to its corresponding
    * data in the Firebase realtime database
    */
  componentWillMount() {
    this.bindAsObject(this.dataURL, 'booth');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the
    * Firebase realtime database
    */
  componentWillUnmount() {
    this.unbind('booth');
  }
  /** @function render
    * Renders the component
    */
  render(){
    if(!this.state.booth) return <Spinner />
    const hall = {
      hallID: "",
      name: "Loading Hall...",
      stage: {
        width: 2048,
        height: 984,
        identifier: "loading hall",
        layers: [
          {
            name: "background",
            type: "pattern",
            x: 0,
            y: 0,
            width: 2048,
            height: 984,
            image: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/editor%2Fpreview-hall.png?alt=media&token=50257007-d039-4cf5-b181-be3c3a261b34",
            order: 1
          },
          {
            name: "other booth 1",
            type: "image",
            image: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/editor%2FBlank_Booth_Icon_1.png?alt=media&token=78b2c8b5-03e1-429e-9146-a184b6c3b125",
            x: 50,
            y: 410,
            width: 550,
            height: 550,
            order: 2
          },
          {
            name: "other booth 2",
            type: "image",
            image: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/editor%2FBlank_Booth_Icon_2.png?alt=media&token=1606c8fb-1b8b-48a8-9252-07a6777e19be",
            x: 50,
            y: 10,
            width: 550,
            height: 550,
            order: 3
          },{
            name: "other booth 3",
            type: "image",
            image: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/editor%2FBlank_Booth_Icon_3.png?alt=media&token=5ffca590-a9d8-4836-a774-5bfe78ecafaa",
            x: 1450,
            y: 410,
            width: 550,
            height: 550,
            order: 4
          },
          {
            name: "other booth 4",
            type: "image",
            image: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/editor%2FBlank_Booth_Icon_4.png?alt=media&token=9f663e64-b474-4e68-b180-90605beff589",
            x: 1450,
            y: 10,
            width: 550,
            height: 550,
            order: 5
          },
          {
            name: "other booth 5",
            type: "image",
            image: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/editor%2FBlank_Booth_Icon_5.png?alt=media&token=7463e0af-28a2-4676-a0ca-a8813a245a74",
            x: 750,
            y: 10,
            width: 550,
            height: 550,
            order: 6
          },
          {
            name: "booth",
            type: "icons",
            icons: [
              {
                id: this.state.boothID,
                name: this.state.booth.metadata.name,
                image: this.state.booth.metadata.icon,
                x: 740,
                y: 400,
                width: 600,
                height: 600,
                published: true,
                url: `/booth-review/${this.state.boothID}/contents`,
                order: 7
              }
            ]
          }
        ]
      }
    }
    return(
      <Editor>
        <Hall {...hall}/>
      </Editor>
    );

  }
}



// WEBPACK FOOTER //
// ./src/booth-reviewer/booth-review-preview.js